import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CloInformationFooter} from './info-footer';


export {CloInformationFooter} from './info-footer';

@NgModule({
  declarations: [CloInformationFooter],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [CloInformationFooter],
  entryComponents: [CloInformationFooter]
})
export class InformationFooterModule {
}
